<template>
    <div class="warning">
        <div class="warning__icon">
            <common-icon name="warning" size="extra-huge"></common-icon>
        </div>
        <div>{{ message }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            message: { type: String, required: true },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .warning {
        display: flex;
        background: $color--accent-10;
        border-radius: 5px;
        line-height: 17px;
        padding: 15px;
        color: white;
        &__icon {
            width: 100px;
            text-align: center;
            margin: auto;
        }
    }
</style>
